import {CookieHandler} from "@/helpers/CookieHandler";
import {domainFolder, isSecure} from "@/helpers/DomainHelper";

export const cookies: CookieHandler = new CookieHandler(
  1,
  window.location.host,
  domainFolder(),
  isSecure(),
);
